import React, { useEffect, useState } from "react";
import fronticon from "../../../Assets/frontIcon.svg";
import back_icon from "../../../Assets/back_icon.svg";
import caret_down_icon from "../../../Assets/caret-down_icon.svg";
import {
  CheckBox,
  MultipleChoice,
  ParagraphAnswer,
  ShortAnswer,
  GridBox,
  CheckBoxGrid,
  Phone,
  Name,
  Website,
  Email,
  Number,
  Spinner,
  Signature,
  Document,
  Date,
  DateAndTime,
  Ratings,
  Dropdown,
  LineScale,
  MultipleChoiceImage,
  VAFileUpload,
  FileUpload,
  Location,
} from "./IndividualResponse/IndividualResponcseComponent";
import sample_signer_image from "../../../Assets/sample_signer_image.png";
import mutipleChoiceImage from "../../../Assets/mutipleChoiceImage.jpg";
import axios from "axios";
import { useParams } from "react-router-dom";

const truncateText = (text, maxLength) => {
  if (text?.length <= maxLength) {
    return text;
  }
  return text?.slice(0, maxLength) + "...";
};

const IndividualView = ({ allUser, userAnswers }) => {
  // const userAnswers = [
  //   {
  //     email: "shimiyon@gamil.com",
  //     form: [
  //       {
  //         formTitle: "Surveyor Form",
  //         formDescription:
  //           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti? Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti?",
  //         questions: [
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ",
  //             options: [
  //               {
  //                 optionImage: mutipleChoiceImage,
  //                 optionText: "Lorem Ipsum",
  //               },
  //               {
  //                 optionImage: mutipleChoiceImage,
  //                 optionText: "Lorem Ipsum hasce the",
  //               },
  //               {
  //                 optionImage: mutipleChoiceImage,
  //                 optionText: "Lorem Ipsu ",
  //               },
  //               {
  //                 optionImage: mutipleChoiceImage,
  //                 optionText: "Lorem the",
  //               },
  //             ],
  //             selectedOption: "Lorem Ipsu ",
  //             type: "Multiple Choice Image",
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ",
  //             minRange: { value: 0, labelName: "Stephen" },
  //             maxRange: { value: 10, labelName: "Lorem Ipsum" },
  //             type: "Line Scale",
  //             answer: { selectedValue: 8 },
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ",
  //             answer:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti?",
  //             type: "Short Answer",
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam t iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti?",
  //             answer:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti?",
  //             type: "Paragraph",
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti?",
  //             options: [
  //               { optionText: "Chennai" },
  //               { optionText: "Erode" },
  //               { optionText: "Coimbatore" },
  //               { optionText: "Madurai" },
  //             ],
  //             selectedOption: "Coimbatore",
  //             type: "Multiple Choice",
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti,",
  //             selectedOptions: ["Chennai", "Coimbatore"],
  //             type: "Check box",
  //             options: [
  //               { optionText: "Chennai" },
  //               { optionText: "Erode" },
  //               { optionText: "Coimbatore" },
  //               { optionText: "Madurai" },
  //             ],
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti",
  //             row: [
  //               { rowText: "Row 1" },
  //               { rowText: "Row 2" },
  //               { rowText: "Row 3" },
  //               { rowText: "Row 3" },
  //             ],
  //             type: "Multiple Choice grid",
  //             column: [
  //               { columnText: "COlumn 1" },
  //               { columnText: "Column 2" },
  //               { columnText: "Column 3" },
  //               { columnText: "Column 4" },
  //             ],
  //             selectedAnswer: [1, 2, 3, 2],
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti",
  //             row: [
  //               { rowText: "Row 1" },
  //               { rowText: "Row 2" },
  //               { rowText: "Row 3" },
  //               { rowText: "Row 3" },
  //             ],
  //             type: "Check box grid",
  //             column: [
  //               { columnText: "COlumn 1" },
  //               { columnText: "Column 2" },
  //               { columnText: "Column 3" },
  //               { columnText: "Column 4" },
  //             ],
  //             selectedAnswer: [
  //               [1, 3],
  //               [0, 2],
  //               [2, 3],
  //               [0, 3],
  //             ],
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             placeHolder: "Phone ( International )",
  //             type: "Phone",
  //             answer: { number: 1234567890 },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             type: "Name",
  //             answer: { firstName: "Shimiyon", lastName: "Samuvel" },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             type: "Website",
  //             answer: {
  //               link: "https://www.w3schools.com/",
  //             },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             type: "Email",
  //             answer: { email: "shimiyon21@gmail.com" },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             placeHolder: "Phone ( International )",
  //             type: "Number",
  //             answer: { number: 1234567890 },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             placeHolder: "Phone ( International )",
  //             type: "Spinner",
  //             answer: { number: 30 },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             placeHolder: "Phone ( International )",
  //             boxWidth: "",
  //             boxHeight: "",
  //             type: "Signature",
  //             answer: { signature: sample_signer_image },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s ",
  //             type: "Document",
  //             answer: { file: "HannahBusing_Resume.pdf" },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s ",
  //             type: "Date",
  //             answer: { date: "10/Apr/2024" },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s ",
  //             type: "DateTime",
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s ",
  //             answer: {
  //               date: "10/Apr/2024",
  //               time: "06:40:PM",
  //             },
  //             type: "Date - Time",
  //           },
  //           {
  //             question: "Lorem Ipsum has been the industry's standard dumm",
  //             answer: { rating: 7 },
  //             typeofdign: "heart",
  //             type: "Ratings",
  //             count: 10,
  //           },
  //           {
  //             question: "Lorem Ipsum has been the industry's standard dumm",
  //             answer: { selectedValue: "Dlip Kumar" },
  //             type: "Dropdown",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     email: "abcdefghshimiyon@gamil.com",
  //     form: [
  //       {
  //         formTitle: "Secound Form",
  //         formDescription:
  //           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti? Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti?",
  //         questions: [
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             placeHolder: "Phone ( International )",
  //             type: "Phone",
  //             answer: { number: 1234567890 },
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti",
  //             row: [
  //               { rowText: "Row 1" },
  //               { rowText: "Row 2" },
  //               { rowText: "Row 3" },
  //               { rowText: "Row 3" },
  //             ],
  //             type: "Check box grid",
  //             column: [
  //               { columnText: "COlumn 1" },
  //               { columnText: "Column 2" },
  //               { columnText: "Column 3" },
  //               { columnText: "Column 4" },
  //             ],
  //             selectedAnswer: [
  //               [1, 3],
  //               [0, 2],
  //               [2, 3],
  //               [0, 3],
  //             ],
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti",
  //             row: [
  //               { rowText: "Row 1" },
  //               { rowText: "Row 2" },
  //               { rowText: "Row 3" },
  //               { rowText: "Row 3" },
  //             ],
  //             type: "Check box grid",
  //             column: [
  //               { columnText: "COlumn 1" },
  //               { columnText: "Column 2" },
  //               { columnText: "Column 3" },
  //               { columnText: "Column 4" },
  //             ],
  //             selectedAnswer: [
  //               [1, 3],
  //               [0, 2],
  //               [2, 3],
  //               [0, 3],
  //             ],
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             type: "Name",
  //             answer: { firstName: "Shimiyon", lastName: "Samuvel" },
  //           },
  //           {
  //             question:
  //               "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  //             type: "Website",
  //             answer: {
  //               link: "https://www.w3schools.com/",
  //             },
  //           },
  //           {
  //             question:
  //               "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti",
  //             row: [
  //               { rowText: "Row 1" },
  //               { rowText: "Row 2" },
  //               { rowText: "Row 3" },
  //               { rowText: "Row 3" },
  //             ],
  //             type: "Check box grid",
  //             column: [
  //               { columnText: "COlumn 1" },
  //               { columnText: "Column 2" },
  //               { columnText: "Column 3" },
  //               { columnText: "Column 4" },
  //             ],
  //             selectedAnswer: [
  //               [1, 3],
  //               [0, 2],
  //               [2, 3],
  //               [0, 3],
  //             ],
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // ];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const maxLength = 25;
  const formId = useParams();

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleSelectChange = (index) => {
    setCurrentIndex(index);
    setDropdownOpen(false);
  };

  const goToNext = () => {
    if (currentIndex < userAnswers.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? userAnswers.length - 1 : prevIndex - 1
    );
  };

  return (
    <>
      <div className="individualView">
        <div className="responce_individualView_container">
          <div className="navigation_container">
            <div className="navigation_numer-container  ">
              <button
                disabled={currentIndex === 0}
                onClick={goToPrevious}
                style={{
                  display: "flex",
                  backgroundColor: "rgba(27, 81, 187, 0.04)",
                  borderRadius: "2rem",
                  alignItems: "center",
                  gap: "0.7rem",
                  marginTop: "0",
                  padding: "0.5rem 1rem",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <img src={back_icon} alt="back_icon" /> {currentIndex + 1}
              </button>
              <p> of</p>
              <button
                onClick={goToNext}
                disabled={currentIndex === userAnswers.length - 1}
                style={{
                  display: "flex",
                  gap: "0.7rem",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(27, 81, 187, 0.04)",
                  borderRadius: "2rem",
                  padding: "0.5rem 1rem",
                  cursor: "pointer",
                  marginTop: "0",
                }}
              >
                {userAnswers.length}
                <img src={fronticon} alt="fronticon" />
              </button>
            </div>
            <div className="custom-dropdown fixed-width">
              <button
                onClick={toggleDropdown}
                className="dropdown-toggle"
                style={{ marginTop: "0" }}
              >
                {truncateText(userAnswers[currentIndex]?.email, maxLength)}
                <img
                  src={caret_down_icon}
                  alt="caret-down_icon"
                  className="dropdown-icon"
                />
              </button>
              {dropdownOpen && (
                <ul className="dropdown-menu">
                  {userAnswers?.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => handleSelectChange(index)}
                      className={`dropdown-item ${
                        index === currentIndex ? "active" : ""
                      }`}
                    >
                      {truncateText(item.email, maxLength)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* {userAnswers[currentIndex].responsesAndQuestion.map((section, index) => (
        <div key={index}> */}
      {/* {userAnswers.map((singleUser, indx) => (
      ))} */}
      <Container allUser={allUser}>
        <div className="answer_container">
          {userAnswers[currentIndex]?.responsesAndQuestion.map(
            (eachQuestion, qindex) => (
              <div key={qindex}>
                <AllQuestions eachQuestion={eachQuestion} index={qindex} />
              </div>
            )
          )}
        </div>
      </Container>
      {/* </div>
      ))} */}
    </>
  );
};

const Container = ({ allUser, children }) => {
  return (
    <div
      style={{
        width: "70%",
        backgroundColor: "#ffffff",
        borderRadius: "0.8rem",
        marginTop: "20px",
      }}
    >
      <div className="topbar_container">
        <div className="individualview_title">{allUser.formTitle}</div>
        <div className="individualview_description">
          {allUser.formDescription}
        </div>
      </div>
      {children}
    </div>
  );
};

const AllQuestions = ({ eachQuestion, index }) => {
  return <div className="">{renderQuestions(eachQuestion, index)}</div>;
};

const renderQuestions = (eachQuestion, index) => {
  switch (eachQuestion.type) {
    case "Short Answer":
      return <ShortAnswer question={eachQuestion} index={index} />;
    case "Paragraph":
      return <ParagraphAnswer question={eachQuestion} index={index} />;
    case "Name":
      return <Name question={eachQuestion} index={index} />;
    case "Phone":
      return <Phone question={eachQuestion} index={index} />;
    case "Multiple Choice":
      return <MultipleChoice question={eachQuestion} index={index} />;
    case "Check box":
      return <CheckBox question={eachQuestion} index={index} />;
    case "Email":
      return <Email question={eachQuestion} index={index} />;
    case "Number":
      return <Number question={eachQuestion} index={index} />;
    case "Line Scale":
      return <LineScale question={eachQuestion} index={index} />;
    case "Date":
      return <Date question={eachQuestion} index={index} />;
    case "Multiple Choice grid":
      return <GridBox question={eachQuestion} index={index} />;
    case "Check box grid":
      return <CheckBoxGrid question={eachQuestion} index={index} />;
    case "Date - Time":
      return <DateAndTime question={eachQuestion} index={index} />;
    case "Website":
      return <Website question={eachQuestion} index={index} />;
    case "Spinner":
      return <Spinner question={eachQuestion} index={index} />;
    case "Dropdown":
      return <Dropdown question={eachQuestion} index={index} />;
    case "Signature":
      return <Signature question={eachQuestion} index={index} />;
    case "Audio/Video Upload":
      return <VAFileUpload question={eachQuestion} index={index} />;
    case "File Upload":
      return <FileUpload question={eachQuestion} index={index} />;
    case "Location":
      return <Location question={eachQuestion} index={index} />;
    // case "Table":
    // case "Document":
    // case "Ratings":
    //   return <Ratings question={eachQuestion} index={index} />;
    // case "Multiple Choice Image":
    //   return <MultipleChoiceImage question={eachQuestion} index={index} />;
    default:
      return null;
  }
};

export default IndividualView;
